import { GravyBinder } from 'gravy-bind';
import { MDCLinearProgress } from '@material/linear-progress';
import { SubscriptionCenterService } from '../services/subscription-center.service';
import { SubscriptionPreference } from '../models/subscription-preference';

export class SubscriptionCenter {
    public static cssClass = 'subscription-center';
    private binder: GravyBinder;
    private rootElement: HTMLFormElement;
    public isSaveComplete: boolean = false;
    private loader: MDCLinearProgress;
    private service: SubscriptionCenterService = new SubscriptionCenterService();

    constructor(rootElement: HTMLElement) {
        this.rootElement = rootElement as HTMLFormElement;
        this.initialize();
    }

    private initialize = async (): Promise<void> => {
        this.binder = new GravyBinder(this, this.rootElement);
        this.loader = new MDCLinearProgress(this.rootElement.querySelector('.mdc-linear-progress'));
        this.loader.determinate = false;
        this.loader.open();

        const preferences = await this.service.getPreferences();
        this.applyPreferences(preferences);
        this.bindEvents();

        this.binder.updateBindings();
        this.loader.close();
    };

    private applyPreferences = (preferences: SubscriptionPreference[]): void => {
        preferences.forEach(pref => {
            const select = this.rootElement.querySelector(`[data-id="${pref.id}"]`) as any;
            if (!select) return;

            const options = select.querySelectorAll('md-select-option');
            options.forEach((opt: any) => opt.removeAttribute('selected'));

            const targetValue = pref.enabled ? 'do-not-send' : 'send';
            const targetOption = select.querySelector(`md-select-option[value="${targetValue}"]`);
            if (targetOption) {
                targetOption.setAttribute('selected', '');
            }

            select.addEventListener('change', () => {
                this.isSaveComplete = false;
                this.binder.updateOutwardBindings();
            });
        });
    };
    
    private bindEvents = (): void => {
        this.rootElement.addEventListener('submit', e => {
            e.preventDefault();
            this.saveChanges();
        });
    };

    public saveChanges = async (): Promise<void> => {
        this.loader.open();
        this.isSaveComplete = false;

        const selects = this.rootElement.querySelectorAll('[data-id]');
        const payload: SubscriptionPreference[] = [];
        for (let i = 0; i < selects.length; i++) {
            const sel = selects[i] as any;
            payload.push({
                id: sel.getAttribute('data-id') as string,
                enabled: sel.value === 'do-not-send' //enable means supression is enabled.
            });
        }

        await this.service.setPreferences(payload);

        this.loader.close();
        this.isSaveComplete = true;
        this.binder.updateOutwardBindings();
    };
}
